import {Component, HostBinding, Input} from '@angular/core';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';


@Component({
  selector: 'app-balloon',
  templateUrl: './balloon.component.html',
  styleUrls: ['./balloon.component.css'],
  animations: [
    trigger('toggleAnimation', [
      state('hide', style({opacity: 0})),
      transition('hide => bottom_middle', [
        animate(200, keyframes([
          style({transform: 'translate(-50%, 20px)', opacity: 0.5, offset: 0}),
          style({transform: 'translate(-50%, 14px)', opacity: 1, offset: 1})
        ]))
      ]),
      transition('hide => bottom_right', [
        animate(200, keyframes([
          style({transform: 'translate(-90%, 20px)', opacity: 0.5, offset: 0}),
          style({transform: 'translate(-90%, 14px)', opacity: 1, offset: 1})
        ]))
      ]),
      transition('hide => right_middle', [
        animate(200, keyframes([
          style({transform: 'translate(103%, -50%)', opacity: 0.5, offset: 0}),
          style({transform: 'translate(100%, -50%)', opacity: 1, offset: 1})
        ]))
      ])
    ])
  ]
})
export class BalloonComponent {

  @Input()direction: 'bottom_middle' | 'bottom_right' | 'right_middle' = 'bottom_middle';
  @HostBinding( 'class.balloonComponent' ) true;

  public get animationStep() {
    return this.isHidden ? 'hide' : this.direction;
  }

  public isHidden = true;

  constructor() { }

  public close() {
    this.isHidden = true;
  }

  public toggle() {
    this.isHidden = !this.isHidden;
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/balloon/balloon.component.ts